import Videos from "../Videos"
export default function Home() {
  return <Videos />
}
